import { motion } from 'framer-motion';

const SvgComponent = ({ transition, ...props }) => (
  <motion.svg

    initial={{
      y: '30%',
      x: '-15%',
      scale: 0.8,
      opacity: 0
    }}
    animate={{
      y: '11%',
      opacity: 1,
      scale: 1,
      transition: { ...transition }
    }}
    exit={{
      y: '30%',
      opacity: 0,
      transition: { ...transition }
    }}
    viewBox="0 0 316 290"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M125.353 106.663H97.787c12.142-15.56 29.016-26.772 48.041-31.989-8.41 9.57-15.351 20.367-20.475 31.989zm-46.877 51.904c.718-15.098 5.165-29.822 13.004-42.76h30.243c-4.866 13.715-7.618 28.162-7.995 42.76H78.476zm35.256 9.145c.443 14.594 3.128 29.042 7.991 42.76H91.48c-7.84-12.939-12.287-27.594-13.005-42.76h35.257zm-16.013 51.905h27.633a122.756 122.756 0 0 0 20.459 31.983 92.132 92.132 0 0 1-48.092-31.983z"
      fill="url(#k39dswre3a)"
      stroke="url(#fovzui7k6b)"
      strokeWidth={1.73}
    />
    <path
      d="M165.54 71.548v35.116H135.6c6.671-13.68 15.584-25.606 26.267-34.928a53.19 53.19 0 0 1 3.673-.188zm-33.914 44.26h33.84v42.76h-42.588c.459-14.67 3.464-29.123 8.748-42.76zm-8.748 51.905h42.662v42.76h-33.914c-5.284-13.636-8.289-28.09-8.748-42.76zm38.989 86.907c-10.634-9.341-19.626-21.295-26.303-35.002h29.976v35.162l-.776-.024a56.747 56.747 0 0 1-2.897-.136z"
      fill="url(#ug8pnik0oc)"
      stroke="url(#ptzz7gbjad)"
      strokeWidth={1.73}
    />
    <path
      d="m175.313 254.681-.629.022v-35.086h27.096c-6.415 12.632-14.456 24.429-23.927 34.935-.848.073-1.681.101-2.54.129zm-.629-183.133a54.8 54.8 0 0 1 3.746.188c10.618 9.325 19.598 21.187 26.272 34.928h-30.018V71.548zm0 44.26h33.914c5.284 13.637 8.289 28.09 8.748 42.76h-42.662v-42.76zm0 51.905h42.481c-.907 13.424-4.563 28.145-10.915 42.76h-31.566v-42.76z"
      fill="url(#2ydxejvtse)"
      stroke="url(#yvllf07bef)"
      strokeWidth={1.73}
    />
    <path
      d="M214.798 106.663a121.478 121.478 0 0 0-20.538-32.006c19.05 5.21 35.948 16.428 48.103 32.006h-27.565zm3.635 9.144h30.237c7.839 12.939 12.286 27.662 13.004 42.76h-35.182c-.442-14.593-3.128-29.041-8.059-42.76zm30.163 94.665h-32.557c5.848-14.447 9.383-29.025 10.137-42.76H261.6c-.718 15.098-5.165 29.822-13.004 42.76zm-56.971 41.949a173.442 173.442 0 0 0 20.41-32.804h30.331c-12.74 16.376-30.618 27.874-50.741 32.804z"
      fill="url(#rqnkzs683g)"
      stroke="url(#dsrhlvxjrh)"
      strokeWidth={1.73}
    />
    <path
      d="M80.038 61.306c-18.854 21.258 2.959 64.85 60.414 103.829 85.814 58.219 137.293 48.437 149.278 36.571 11.984-11.866-.609-39.162-19.134-52.752"
      stroke="url(#hez91nafgi)"
      strokeWidth={3}
      strokeLinecap="round"
      style={{
        mixBlendMode: "luminosity",
      }}
      opacity={0.4}
    />
    <g filter="url(#37ncux862j)" transform="rotate(52.88 226.786 207.857)">
      <circle cx={226.786} cy={207.857} r={15.603} fill="url(#wczt1o2dmk)" />
      <circle
        cx={226.786}
        cy={207.857}
        r={14.603}
        stroke="url(#gg0aagcual)"
        strokeWidth={2}
      />
    </g>
    <g filter="url(#92yiw12pkm)" transform="rotate(52.88 97.98 128.678)">
      <circle cx={97.981} cy={128.678} r={10.848} fill="url(#l98iw953mn)" />
      <circle
        cx={97.981}
        cy={128.678}
        r={9.733}
        stroke="url(#gim7hu9koo)"
        strokeWidth={2.229}
      />
    </g>
    <g filter="url(#xln76j8u7p)" transform="rotate(52.88 251.767 211.315)">
      <circle cx={251.767} cy={211.315} r={4.458} fill="url(#4worm4lqoq)" />
      <circle
        cx={251.767}
        cy={211.315}
        r={3.458}
        stroke="url(#smhppe8z5r)"
        strokeWidth={2}
      />
    </g>
    <g filter="url(#8v79ycsb4s)" transform="rotate(52.88 80.022 120.477)">
      <circle cx={80.022} cy={120.477} r={4.458} fill="url(#1li99clgbt)" />
      <circle
        cx={80.022}
        cy={120.477}
        r={3.343}
        stroke="url(#7mfgxyx6au)"
        strokeWidth={2.229}
      />
    </g>
    <g filter="url(#i12uxbshdv)" transform="rotate(52.88 289.467 200.736)">
      <circle cx={289.467} cy={200.736} r={8.916} fill="url(#3oduufh5gw)" />
      <circle
        cx={289.467}
        cy={200.736}
        r={7.801}
        stroke="url(#rekxdswcsx)"
        strokeWidth={2.229}
      />
    </g>
    <g filter="url(#kti388vify)" transform="rotate(52.88 302.653 208.926)">
      <circle cx={302.653} cy={208.926} r={3.343} fill="url(#j696qmjl9z)" />
      <circle
        cx={302.653}
        cy={208.926}
        r={2.229}
        stroke="url(#ztxl3wti0A)"
        strokeWidth={2.229}
      />
    </g>
    <path
      d="M53.605 239.345c18.287 21.747 64.59 6.513 111.517-44.656 70.091-76.426 67.907-128.78 57.912-142.364-9.995-13.585-33.194-7.212-47.219 4.296"
      stroke="url(#h6e6j7x4zB)"
      strokeWidth={3}
      strokeLinecap="round"
      style={{
        mixBlendMode: "luminosity",
      }}
      opacity={0.4}
    />
    <g filter="url(#dvemz5vqyC)" transform="rotate(-28.75 190.913 47.068)">
      <circle cx={190.913} cy={47.068} r={6.687} fill="url(#xih74vpp9D)" />
      <circle
        cx={190.913}
        cy={47.068}
        r={5.687}
        stroke="url(#2gio42qzhE)"
        strokeWidth={2}
      />
    </g>
    <g filter="url(#h9jo1bckmF)" transform="rotate(-28.75 177.926 46.565)">
      <circle cx={177.926} cy={46.565} r={2.229} fill="url(#rd82v211dG)" />
      <circle
        cx={177.926}
        cy={46.565}
        r={1.229}
        stroke="url(#tzzt56sx4H)"
        strokeWidth={2}
      />
    </g>
    <g filter="url(#2s57scy9aI)" transform="rotate(-28.75 193.723 156.296)">
      <circle cx={193.723} cy={156.296} r={15.603} fill="url(#iza9fe03hJ)" />
      <circle
        cx={193.723}
        cy={156.296}
        r={14.603}
        stroke="url(#ohlhp95rzK)"
        strokeWidth={2}
      />
    </g>
    <g filter="url(#lke00aue2L)" transform="rotate(4.023 120.524 233.608)">
      <circle cx={120.524} cy={233.608} r={11.212} fill="url(#xk2989pkjM)" />
      <circle
        cx={120.524}
        cy={233.608}
        r={10.212}
        stroke="url(#5co0ovpwiN)"
        strokeWidth={2}
      />
    </g>
    <g filter="url(#igbhwvynmO)" transform="rotate(-28.75 200.778 132.087)">
      <circle cx={200.778} cy={132.087} r={4.458} fill="url(#wcpnqv21iP)" />
      <circle
        cx={200.778}
        cy={132.087}
        r={3.458}
        stroke="url(#0vt4knqztQ)"
        strokeWidth={2}
      />
    </g>
    <g filter="url(#4c112j455R)" transform="rotate(4.023 104.785 221.941)">
      <circle cx={104.785} cy={221.941} r={4.458} fill="url(#xlhbiwya8S)" />
      <circle
        cx={104.785}
        cy={221.941}
        r={3.458}
        stroke="url(#78cwq533tT)"
        strokeWidth={2}
      />
    </g>
    <g filter="url(#108bxj11mU)" transform="rotate(-46.056 228.403 73.104)">
      <circle cx={228.403} cy={73.104} r={8.916} fill="url(#6pqakdjs9V)" />
      <circle
        cx={228.403}
        cy={73.104}
        r={7.916}
        stroke="url(#rwkzm425tW)"
        strokeWidth={2}
      />
    </g>
    <g filter="url(#e1wdsn8xrX)" transform="rotate(-46.056 234.445 58.804)">
      <circle cx={234.445} cy={58.804} r={3.343} fill="url(#yj82io4rzY)" />
      <circle
        cx={234.445}
        cy={58.804}
        r={2.343}
        stroke="url(#pwmpaear1Z)"
        strokeWidth={2}
      />
    </g>
    <defs>
      <linearGradient
        id="k39dswre3a"
        x1={111.968}
        y1={31.972}
        x2={111.968}
        y2={430.62}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="ug8pnik0oc"
        x1={143.563}
        y1={28.39}
        x2={143.563}
        y2={438.039}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="2ydxejvtse"
        x1={195.393}
        y1={28.407}
        x2={195.393}
        y2={437.891}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="rqnkzs683g"
        x1={224.939}
        y1={31.819}
        x2={224.939}
        y2={431.945}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="hez91nafgi"
        x1={216.125}
        y1={18.051}
        x2={-26.441}
        y2={334.322}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="wczt1o2dmk"
        x1={211.183}
        y1={223.46}
        x2={238.542}
        y2={196.1}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="l98iw953mn"
        x1={87.133}
        y1={139.526}
        x2={106.155}
        y2={120.504}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="4worm4lqoq"
        x1={247.309}
        y1={215.773}
        x2={255.126}
        y2={207.956}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="1li99clgbt"
        x1={75.564}
        y1={124.935}
        x2={83.381}
        y2={117.118}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="3oduufh5gw"
        x1={280.551}
        y1={209.652}
        x2={296.185}
        y2={194.018}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="j696qmjl9z"
        x1={299.309}
        y1={212.269}
        x2={305.172}
        y2={206.407}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="h6e6j7x4zB"
        x1={30.162}
        y1={97.577}
        x2={309.705}
        y2={384.741}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="xih74vpp9D"
        x1={184.226}
        y1={53.755}
        x2={195.952}
        y2={42.029}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="rd82v211dG"
        x1={175.697}
        y1={48.794}
        x2={179.605}
        y2={44.886}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="iza9fe03hJ"
        x1={178.12}
        y1={171.899}
        x2={205.48}
        y2={144.539}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="xk2989pkjM"
        x1={109.312}
        y1={244.82}
        x2={128.972}
        y2={225.16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="wcpnqv21iP"
        x1={196.32}
        y1={136.545}
        x2={204.137}
        y2={128.728}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="xlhbiwya8S"
        x1={100.327}
        y1={226.399}
        x2={108.144}
        y2={218.582}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="6pqakdjs9V"
        x1={219.487}
        y1={82.02}
        x2={235.121}
        y2={66.386}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="yj82io4rzY"
        x1={231.102}
        y1={62.148}
        x2={236.965}
        y2={56.285}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.25} stopColor="#fff" stopOpacity={0.205} />
        <stop offset={0.487} stopColor="#fff" stopOpacity={0.104} />
        <stop offset={0.719} stopColor="#fff" stopOpacity={0.032} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <radialGradient
        id="fovzui7k6b"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-68.529 224.591 69.644) scale(143.733 97.9195)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="ptzz7gbjad"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(32.9989 -137.4493 62.40104 14.98128 121.989 255.679)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="yvllf07bef"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-76.495 249.042 17.548) scale(141.301 64.1727)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="dsrhlvxjrh"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-67.952 283.022 -13.608) scale(144.847 100.794)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="gg0aagcual"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 375.332 -143.19) scale(32.7874)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="gim7hu9koo"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 211.99 -35.416) scale(22.7954)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="smhppe8z5r"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 384.116 -190.642) scale(9.36783)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="7mfgxyx6au"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 188.592 -28.746) scale(9.36783)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="rekxdswcsx"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 393.348 -233.829) scale(18.7357)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="ztxl3wti0A"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 405.886 -255.163) scale(7.02587)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="2gio42qzhE"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 157 -195.503) scale(14.0517)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="tzzt56sx4H"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 146.748 -187.688) scale(4.68392)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="ohlhp95rzK"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 296.56 -129.06) scale(32.7874)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="5co0ovpwiN"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 350.18 -9.541) scale(23.5606)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="0vt4knqztQ"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 262.984 -168.707) scale(9.36783)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="78cwq533tT"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 323.451 -7.906) scale(9.36783)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="rwkzm425tW"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 208.75 -223.934) scale(18.7357)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="pwmpaear1Z"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-45 190.57 -247.89) scale(7.02587)"
      >
        <stop offset={0.173} stopColor="#fff" stopOpacity={0.6} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <filter
        id="37ncux862j"
        x={181.182}
        y={162.254}
        width={91.207}
        height={91.207}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={15} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="92yiw12pkm"
        x={35.243}
        y={65.94}
        width={125.476}
        height={125.476}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={25.945} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="xln76j8u7p"
        x={195.419}
        y={154.967}
        width={112.696}
        height={112.696}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={25.945} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="8v79ycsb4s"
        x={23.674}
        y={64.129}
        width={112.696}
        height={112.696}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={25.945} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="i12uxbshdv"
        x={228.661}
        y={139.93}
        width={121.612}
        height={121.612}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={25.945} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="kti388vify"
        x={247.419}
        y={153.692}
        width={110.467}
        height={110.467}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={25.945} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="dvemz5vqyC"
        x={132.335}
        y={-11.51}
        width={117.156}
        height={117.156}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={25.945} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="h9jo1bckmF"
        x={123.806}
        y={-7.554}
        width={108.239}
        height={108.239}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={25.945} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="2s57scy9aI"
        x={148.117}
        y={110.691}
        width={91.211}
        height={91.211}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={15} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="lke00aue2L"
        x={79.311}
        y={192.396}
        width={82.425}
        height={82.425}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={15} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="igbhwvynmO"
        x={144.429}
        y={75.739}
        width={112.698}
        height={112.697}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={25.945} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="4c112j455R"
        x={48.436}
        y={165.593}
        width={112.696}
        height={112.696}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={25.945} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="108bxj11mU"
        x={189.486}
        y={34.188}
        width={77.832}
        height={77.832}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={15} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
      <filter
        id="e1wdsn8xrX"
        x={179.212}
        y={3.571}
        width={110.467}
        height={110.467}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={25.945} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10273"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10273"
          result="shape"
        />
      </filter>
    </defs>
  </motion.svg>
)

export default SvgComponent
